let interval = setInterval(function () {
  let apElements = document.querySelector('.apo-cart-item');
  if (apElements){
    document.querySelector("a.CartItem__Remove").addEventListener("click", function() {
      location.reload();
    });
    var quantityButtons = document.querySelectorAll(".QuantitySelector a");
    quantityButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        location.reload();
      });
    });
  }
}, 100);
